(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-scratch/assets/javascripts/utils/tickets-radio-dispatcher.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-scratch/assets/javascripts/utils/tickets-radio-dispatcher.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class TicketsRadioDispatcher {
  constructor() {
    this.getGamesListeners = [];
    this.pausedEvents = [];
    this.eventListeners = [];
    this.handleResponse = this.handleResponse.bind(this);
  }
  handleResponse(queryName, result) {
    if (this.isPaused) {
      return this.pausedEvents.push(() => {
        this.handleResponse(queryName, result);
      });
    }
    switch (queryName) {
      case 'TICKETINFO_CHANGE':
        this.ticketInfo = result;
        this.eventListeners.forEach(event => {
          if (event.eventName === queryName) {
            event.handler(result);
          }
        });
        break;
      default:
        this.eventListeners.forEach(event => {
          if (event.eventName === queryName) {
            event.handler(result);
          }
        });
    }
  }

  sendAnalytics(transactionId, gameId, ticketPrice, ticketInfo) {
    let shouldHaveExtraData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);
    if (ticketInfo) {
      const items = [];
      const productName = ticketInfo.name;
      const extraData = {
        gameType: ticketInfo.type
      };
      const trackingItem = new svs.components.analytics.transactionItem(gameId, ticketInfo.name, ticketPrice, 1, shouldHaveExtraData ? extraData : undefined);
      items.push(trackingItem);
      const transaction = new svs.components.analytics.transaction(transactionId, ticketPrice, items, 0, 0, undefined, capitalize(productName));
      svs.components.analytics.trackTransaction(transaction);
    }
  }
  addListeners(events, observer) {
    this.eventListeners = [...this.eventListeners, ...events.map(obj => _objectSpread(_objectSpread({}, obj), {}, {
      observer
    }))];
  }
  removeListeners(observer) {
    this.eventListeners = this.eventListeners.filter(event => event.observer !== observer);
  }
  setPaused(isPaused) {
    this.isPaused = isPaused;
    if (!isPaused) {
      this.pausedEvents.forEach(event => event());
      this.pausedEvents = [];
    }
  }
}
setGlobal('svs.ticketgames.ticketScratch.utils.TicketsRadioDispatcher', TicketsRadioDispatcher);

 })(window);